import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import Panel from "Portal/NewPortal/Shared/Panel";

import { Div } from "components/Base";

import {
  getSessions,
  getMySessionsTitle,
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize,
  getSectionIconById
} from "Portal/NewPortal/PortalHome/selectors";

import Session from "./Session";

import { noop } from "utils/General";

import { actions } from "Portal/NewPortal/PortalHome/model";

import { SECTIONS_IDS } from "Portal/NewPortal/PortalHome/constants";

const decorate = R.compose(
  connect(
    state => ({
      sessions: getSessions(state),
      mySessionsTitle: getMySessionsTitle(state),
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state)
    }),
    {
      onClickPanelHeader: actions.setSelectedCategory
    }
  )
);

const Sessions = ({
  sessions = [],
  mySessionsTitle = null,
  onClickPanelHeader = noop
}) => {
  if (R.isEmpty(sessions)) {
    return null;
  }

  const icon = getSectionIconById(SECTIONS_IDS.SESSIONS) || null;
  return (
    <Panel
      title={mySessionsTitle}
      length={sessions.length}
      panelContainerStyle={{
        maxHeight: "400px",
        height: "auto",
        overflow: "auto"
      }}
      icon={icon}
      onClickHeader={() =>
        onClickPanelHeader({ category: SECTIONS_IDS.SESSIONS })
      }
    >
      <Div display="column.flex-start.flex-end" style={{ gap: "12px" }}>
        {R.map(session => {
          const subsessions = R.propOr([], "subsessions", session);
          return (
            <>
              <Session key={session.id} {...session} />
              {R.map(
                ss => (
                  <Session key={ss.id} parentStatus={session.status} {...ss} />
                ),
                subsessions
              )}
            </>
          );
        }, sessions)}
      </Div>
    </Panel>
  );
};

export default decorate(Sessions);
